import { Box, Spinner } from '@ouster/webviz-react-components';

import { RiUser3Line } from 'react-icons/ri';

import DashboardCard from './DashboardCard';
import InfoItem from './InfoItem';
import { UserInfo } from './types';

interface UserLookUpStudioInfoProps {
  isUserFound: boolean;
  studioUserInfo: UserInfo | null;
  isLoadingUserLookup: boolean;
}

export default function UserLookUpStudioInfo({
  isUserFound,
  studioUserInfo,
  isLoadingUserLookup,
}: UserLookUpStudioInfoProps) {
  const cardProps = {
    icon: <RiUser3Line size={20} />,
    title: 'Studio User',
  };

  if (isLoadingUserLookup) {
    return (
      <DashboardCard {...cardProps} data-testid="user-lookup-studio-card">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          my={8}
          data-testid="user-lookup-studio-loading"
        >
          <Spinner />
        </Box>
      </DashboardCard>
    );
  }

  if (!isUserFound) return null;

  if (!studioUserInfo) {
    return (
      <DashboardCard {...cardProps} data-testid="user-lookup-studio-card">
        <Box my={8} data-testid="user-lookup-studio-empty">
          User does not exist in Studio
        </Box>
      </DashboardCard>
    );
  }

  const userInfoItems = [
    { label: 'Display Name', value: studioUserInfo.name },
    { label: 'Email', value: studioUserInfo.email },
    { label: 'User ID', value: studioUserInfo.id },
    { label: 'Identity ID', value: studioUserInfo.identity_id },
  ];

  return (
    <DashboardCard {...cardProps} data-testid="user-lookup-studio-card">
      <Box
        display="grid"
        gridTemplateColumns="repeat(3, 1fr)"
        columnGap={4}
        rowGap={6}
        data-testid="user-lookup-studio-grid"
      >
        {userInfoItems.map((item) => (
          <InfoItem
            key={item.label}
            label={item.label}
            value={item.value}
            data-testid={`user-lookup-studio-item-${item.label
              .toLowerCase()
              .replace(/\s/g, '-')}`}
          />
        ))}
      </Box>
    </DashboardCard>
  );
}
